// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import AuthService from 'shared_ui_components/src/auth/AuthService'
import createRouter from './router'
import './style.less'

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(Router)

const authService =
  new AuthService(process.env.AUTH_SERVICE_URL, location.origin + location.pathname)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: createRouter({authService}),
  provide: {authService},
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// /src/main.js